import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { useMemo } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { themeSettings } from "theme";
import Layout from "scenes/layout";
import Dashboard from "scenes/dashboard";
import Login from "scenes/login";
import PrivateRoute from "routes/PrivateRoute";
import NotFound from "scenes/notfound";
import LoadingBackdrop from "components/LoadingBackdrop";
import Notifikasi from "scenes/notifikasi";
import Stockopname from "scenes/stockopname";
import AbsensiHariIni from "scenes/absensihariini";
import RekapAbsensiBulanan from "scenes/rekapabsensibulanan";
import PesertaSO from "scenes/pesertaso";
import Divisi from "scenes/divisi";
import Jabatan from "scenes/jabatan";
import Departemen from "scenes/departemen";
import Panduan from "scenes/panduan";
import Aspirasi from "scenes/aspirasi";
import Peringatan from "scenes/peringatan";
import RekapAbsensiHarian from "scenes/rekapabsensiharian";
import Setoran from "scenes/setoran";
import Penggajian from "scenes/penggajian";
import AddPenggajian from "scenes/penggajian/addPenggajian";
import CetakSlip from "scenes/penggajian/cetakSlip";
import Pencapaian from "scenes/pencapaian";
import TarikTabungan from "scenes/tariktabungan";
import EditPenggajian from "scenes/penggajian/editPenggajian";
import SetorTabungan from "scenes/setortabungan";
import Tabungan from "scenes/tabungan";
import Jenjang from "scenes/jenjang";
import KaryawanBaru from "scenes/karyawanbaru";
import CetakLaporanGaji from "scenes/penggajian/cetakLaporanGaji";
import RekapTabunganBulanan from "scenes/rekaptabunganbulanan";
import CetakRekapTabungan from "scenes/rekaptabunganbulanan/cetakRekapTabungan";
import AlokasiDC from "scenes/alokasidc";
import CetakAlokasi from "scenes/alokasidc/cetakAlokasi";
import BukuWarkat from "scenes/bukuwarkat";

function App() {
  const theme = useMemo(() => createTheme(themeSettings("light")), []);
  return (
    <div className="app">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <LoadingBackdrop />
          <Routes>
            {/* Rute untuk login */}
            <Route path="/login" element={<Login />} />

            {/* Rute utama dengan Layout */}
            <Route element={<Layout />}>
              {/* Jika belum login, arahkan ke login */}
              <Route
                path="/"
                element={
                  <PrivateRoute
                    element={<Navigate to="/dashboard" replace />}
                    redirectTo="/login"
                  />
                }
              />
              <Route
                path="/dashboard"
                element={<PrivateRoute element={<Dashboard />} />}
              />
              <Route
                path="/departemen"
                element={<PrivateRoute element={<Departemen />} />}
              />
              <Route
                path="/divisi"
                element={<PrivateRoute element={<Divisi />} />}
              />
              <Route
                path="/jabatan"
                element={<PrivateRoute element={<Jabatan />} />}
              />
              {/* <Route
                path="/karyawan"
                element={<PrivateRoute element={<Karyawan />} />}
              /> */}
              <Route
                path="/karyawanbaru"
                element={<PrivateRoute element={<KaryawanBaru />} />}
              />
              <Route
                path="/pesertaso"
                element={<PrivateRoute element={<PesertaSO />} />}
              />
              <Route
                path="/notifikasi"
                element={<PrivateRoute element={<Notifikasi />} />}
              />
              <Route
                path="/panduan"
                element={<PrivateRoute element={<Panduan />} />}
              />
              <Route
                path="/aspirasi"
                element={<PrivateRoute element={<Aspirasi />} />}
              />
              <Route
                path="/peringatan"
                element={<PrivateRoute element={<Peringatan />} />}
              />
              <Route
                path="/tabungan"
                element={<PrivateRoute element={<Tabungan />} />}
              />
              <Route
                path="/rekaptabungan"
                element={<PrivateRoute element={<RekapTabunganBulanan />} />}
              />
              <Route
                path="/tariktabungan"
                element={<PrivateRoute element={<TarikTabungan />} />}
              />
              <Route
                path="/setortabungan"
                element={<PrivateRoute element={<SetorTabungan />} />}
              />
              <Route
                path="/stockopname"
                element={<PrivateRoute element={<Stockopname />} />}
              />
              <Route
                path="/absensihariini"
                element={<PrivateRoute element={<AbsensiHariIni />} />}
              />
              <Route
                path="/rekapabsensiharian"
                element={<PrivateRoute element={<RekapAbsensiHarian />} />}
              />
              <Route
                path="/rekapabsensibulanan"
                element={<PrivateRoute element={<RekapAbsensiBulanan />} />}
              />
              <Route
                path="/setoran"
                element={<PrivateRoute element={<Setoran />} />}
              />
              <Route
                path="/penggajian"
                element={<PrivateRoute element={<Penggajian />} />}
              />
              <Route
                path="/addpenggajian"
                element={<PrivateRoute element={<AddPenggajian />} />}
              />
              <Route
                path="/editpenggajian"
                element={<PrivateRoute element={<EditPenggajian />} />}
              />
              <Route
                path="/pencapaian"
                element={<PrivateRoute element={<Pencapaian />} />}
              />
              <Route
                path="/jenjang"
                element={<PrivateRoute element={<Jenjang />} />}
              />
              <Route
                path="/alokasidc"
                element={<PrivateRoute element={<AlokasiDC />} />}
              />
              <Route
                path="/bukuwarkat"
                element={<PrivateRoute element={<BukuWarkat />} />}
              />
            </Route>
            <Route path="/slip-gaji" element={<CetakSlip />} />
            <Route path="/laporan-gaji" element={<CetakLaporanGaji />} />
            <Route
              path="/cetak-rekap-tabungan"
              element={<CetakRekapTabungan />}
            />
            <Route path="/cetak-alokasi" element={<CetakAlokasi />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
